module.exports = __webpack_public_path__ + "static/media/staff.36b09f03.svg";